export default "__VITE_ASSET__CMTcdhfG__"